export type SavedAngleStage = "all" | "tof" | "mof" | "bof";

export const SAVED_ANGLE_STAGE_OPTIONS: { value: SavedAngleStage; label: string }[] = [
  { value: "all", label: "All stages" },
  { value: "tof", label: "Top of funnel" },
  { value: "mof", label: "Mid funnel" },
  { value: "bof", label: "Bottom of funnel" },
];

export function filterSavedAnglesByStage<A extends { funnelStage?: string | null }>(
  angles: A[],
  stage: SavedAngleStage,
  enabled: boolean,
): A[] {
  return !enabled || stage === "all" ? angles : angles.filter((angle) => angle.funnelStage === stage);
}